<template>
  <div>
    <!-- Button trigger modal -->
    <!-- 利用規約同意 -->
    <hr />
    <div class="left" style="margin-top: 20px">
      <div v-if="showCheckbox === 'true'">
        <span style="font-size: 130%">{{ruleExplanation}}</span>
      </div>
      <div class="row" style="margin-top: 20px">
        <div class="col" style="max-width: 12rem">
          <button
            type="button"
            class="btn btn-link btn-padding-2"
            data-toggle="modal"
            data-target="#concentModalLong"
          >
            利用規約はこちら
          </button>
        </div>
        <div
          class="col-xs d-flex align-items-center"
          style="align-content: flex-start"
          v-if="showCheckbox === 'true'"
        >
          <div class="custom-control custom-checkbox">
            <input
              class="custom-control-input"
              type="checkbox"
              id="consentFlagBool"
              :checked="invalidCheck"
              @change="toggleConsentCheck"
            />
            <label class="custom-control-label" for="consentFlagBool">
              同意します
              <span
                class="badge badge-pill badge badge-light"
                style="color: #ff0000"
                >必須</span
              >
            </label>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <!-- Modal -->
    <div
      class="modal fade"
      id="concentModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="concentModalLongTitle"
      aria-hidden="true"
    >
      <!-- <div class="modal-dialog modal-dialog-scrollable" role="document"> -->
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="concentModalLongTitle">利用規約</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-html="consent"></div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Consent",
  data() {
    return {
      consent: "",
    };
  },
  props: {
    invalidCheck: Boolean,
    path: String,
    showCheckbox: String,
    ruleExplanation: String,
  },
  model: {
    prop: 'invalidCheck',
    event: 'change'
  },  
  mounted() {
    this.load([this.path]);
  },
  methods: {
    // 利用規約ロード
    load(path) {
      fetch(path).then((res) => {
        res.text().then((html) => {
          this.consent = html;
        });
      });
    },
    // 同意チェック
    toggleConsentCheck() {
        this.$emit('toggleConsentCheck', !this.invalidCheck);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
